import KCBTypeColumn from "components/common/ColumnColors/KCBTypeColumn/KCBTypeColumn";
import {
  convertIosDateToString,
  formatToCurrencyTypeFloor,
  toNumber,
} from "helper/common";
import {FIELD_TYPE} from "types/enums";
import {ColumnsEdit} from "types/models/column-table-edit";
import {DataFormField} from "types/models/input-field-type";
import React from "react";

const {DATE} = FIELD_TYPE;

const dataField: DataFormField[] = [
  {
    type: DATE,
    label: "Thời gian từ",
    name: "ngayBatDau",
    rules: [{required: true, message: "Chưa nhập ngày bắt đầu"}],
    // optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
  },
  {
    type: DATE,
    label: "Thời gian đến",
    name: "ngayKetThuc",
    rules: [{required: true, message: "Chưa nhập ngày kết thúc"}],
    // optionsTime: { showTime: true, format: FORMAT_TIME.dateTime },
  },
];

const columnsTable: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    width: "40px",
    align: "center",
    fixed: "left",
  },
  {
    title: "Tên bác sĩ",
    dataIndex: "hoTen",
    key: "hoTen",
    width: "120px",
  },
  {
    title: "Tổng số ca khám bệnh",
    dataIndex: "soCaKhamBenh",
    key: "soCaKhamBenh",
    width: "70px",
    align: "right",
  },
  {
    title: "Tổng số ca phẫu thuật",
    dataIndex: "soCaPhauThuat",
    key: "soCaPhauThuat",
    width: "70px",
    align: "right",
  },
  {
    title: "Tổng số ca thủ thuật",
    dataIndex: "soCaThuThuat",
    key: "soCaThuThuat",
    width: "70px",
    align: "right",
  },
  {
    title: "Số ca khám miễn phí",
    dataIndex: "soCaKhamMienPhi",
    key: "soCaKhamMienPhi",
    width: "70px",
    align: "right",
  },
  {
    title: "Số ca khám gói khám",
    dataIndex: "soCaKhamGoiKham",
    key: "soCaKhamGoiKham",
    width: "70px",
    align: "right",
  },
  {
    title: "Thời gian chờ trung bình",
    dataIndex: "thoiGianChoTb",
    key: "thoiGianChoTb",
    width: "70px",
    align: "right",
  },
  {
    title: "Thời gian khám trung bình",
    dataIndex: "thoiGianKhamTb",
    key: "thoiGianKhamTb",
    width: "70px",
    align: "right",
  },
  {
    title: "Doanh thu ngoại trú",
    dataIndex: "doanhThuNgoaiTru",
    key: "doanhThuNgoaiTru",
    width: "100px",
    align: "right",
    render: (value, record, index) => {
      return <div>{formatToCurrencyTypeFloor(value)}</div>;
    },
  },
  {
    title: "Doanh thu nội trú",
    dataIndex: "doanhThuNoiTru",
    key: "doanhThuNoiTru",
    width: "100px",
    align: "right",
    render: (value, record, index) => {
      return <div>{formatToCurrencyTypeFloor(value)}</div>;
    },
  },
  {
    title: "Tổng doanh thu",
    dataIndex: "tongDoanhThu",
    key: "tongDoanhThu",
    width: "100px",
    align: "right",
    render: (value, record: any, index) => {
      return (
        <div>
          {formatToCurrencyTypeFloor(
            toNumber(record?.doanhThuNoiTru) +
              toNumber(record?.doanhThuNgoaiTru)
          )}
        </div>
      );
    },
  },
  // {
  //   title: "Số ngày làm việc",
  //   dataIndex: "soNgayLamViec",
  //   key: "soNgayLamViec",
  //   width: "70px",
  //   align: "right",
  // },
  // {
  //   title: "Số ngày làm việc tại phòng khám",
  //   dataIndex: "soNgayLamViecNgoaiTru",
  //   key: "soNgayLamViecNgoaiTru",
  //   width: "100px",
  //   align: "right",
  // },

  // {
  //   title: "Số ngày làm việc nội trú",
  //   dataIndex: "soNgayLamViecNoiTru",
  //   key: "soNgayLamViecNoiTru",
  //   width: "100px",
  //   align: "right",
  // },
];

export {dataField, columnsTable};
